import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from "react-router-dom";
import './index.css';
import App from './App';
import {store} from "./redux/store";
import {Provider} from "react-redux";
import {SportProvider} from "./components/sport/sport-provider";

ReactDOM.render(
    <BrowserRouter>
        <Provider store={store}>
           <SportProvider />
            <App/>
        </Provider>
    </BrowserRouter>,
    document.getElementById('root')
);
